/*@ngInject*/
const AuthenticationMediator = function ($q, $uibModal, loginRepository, loginTokenRepository, refreshLoginTokenRepository, changePasswordRepository, changePasswordWithTokenRepository) {

    function refreshLoginTokenInternal(loginTokenToRefresh) {
        let defer = $q.defer();

        function onSuccess(newLoginToken) {
            loginTokenRepository.setLoginToken(newLoginToken);
            defer.resolve();
        }

        function onError() {
            defer.reject();
        }

        refreshLoginTokenRepository.refreshLoginToken(loginTokenToRefresh).then(onSuccess, onError);
        return defer.promise;
    }

    this.refreshLoginToken = (loginToken) => {
        return refreshLoginTokenInternal(loginToken);
    };

    this.refreshLoginTokenWithCurrent = () => {
        return refreshLoginTokenInternal(loginTokenRepository.getLoginToken());
    };

    this.showChangePasswordPopup = (loginToken) => {
        $uibModal.open({
            templateUrl: '/changePasswordModal/changePasswordModal.tpl.html',
            controller: 'changePasswordModalController',
            windowClass: 'changePasswordModal',
            backdrop: 'static',
            resolve: {
                options: function () {
                    return {
                        loginToken: loginToken
                    };
                }
            }
        });
    };

    this.showForgotPassword = () => {
        $uibModal.open({
            templateUrl: '/login/forgotPassword/forgotPassword.tpl.html',
            controller: 'forgotPasswordController',
            backdrop: 'static',
            windowClass: 'forgotPasswordModal'
        });
    };

    this.changePasswordAndLogin = function(username, oldPassword, newPassword, timeoutSeconds, passwordIsToken) {
        return loginRepository.changePasswordAndLogin(username, oldPassword, newPassword, timeoutSeconds, passwordIsToken);
    };

    this.changePassword = (username, oldPassword, newPassword) => {
        return changePasswordRepository.changePassword(username, oldPassword, newPassword);
    };

    this.changePasswordWithToken = (username, loginToken, newPassword) => {
        return changePasswordWithTokenRepository.changePasswordWithToken(username, loginToken, newPassword);
    };
};

angular.module('gw-um-auth')
    .service('authenticationMediator', AuthenticationMediator);
